import React, { useState, useEffect, createRef } from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import "./TitleEditable.scss";

const TitleEditable = props => {
  const [value, setValue] = useState(props.value || '');
  const [isDisabled, setIsDisabled] = useState(true);
  const titleRef = createRef();

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    if (!isDisabled) {
      titleRef.current.focus();
    }
  }, [isDisabled]);

  const onSaveChange = e => {
    e.stopPropagation();

    if (value === props.value) {
      setIsDisabled(true);
      return;
    }
    
    props.onChange(value);
    setIsDisabled(true);
  }

  const onClickCancel = e => {
    e.stopPropagation();

    setIsDisabled(true);
    setValue(props.value || '');
  }

  const onClickEditing = e => {
    if (props.editable) {
      setIsDisabled(false);
    }
  }

  return (
    <div className={`${props.className} editable-title${isDisabled ? '' : ' editing'} ${props.editable ? 'customizable' : ''}`} onClick={onClickEditing}>
      <InputGroup>
        {props.prepend && 
          <InputGroup.Prepend>
            <InputGroup.Text id="impact-price">{props.prepend}</InputGroup.Text>
          </InputGroup.Prepend>
        }
        {isDisabled && (
          <div className="disabled-wrapper">{value}</div>
        )}
        {!isDisabled && (
          <FormControl
            id="titleEditor"
            placeholder=""
            aria-label="Title"
            aria-describedby="title"
            value={value}
            onChange={(e) => setValue(e.target.value && e.target.value !== '' ? e.target.value : null)}
            ref={titleRef}
            onKeyPress={(event) => {
              if ((event.key === "Enter") && !isDisabled) {
                onSaveChange(event);
              }
            }}
          />
        )}
      </InputGroup>
      {!isDisabled && <div className="editor-actions">
        <div className="editor-button mr-1" onClick={onSaveChange}>
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <div className="editor-button" onClick={onClickCancel}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
      }
    </div>
  );
}

export default TitleEditable;
